module.exports = __webpack_public_path__ + "static/Customize-Colours-2-e1403553594623-82e8a52126f5d0832d84bd54f8cb319a.jpg";